import React, { useEffect } from 'react'
import './htmlViewer.css'
import { useState } from 'react'


export const HtmlViewer = ({ content, cssClass = 'training-text', showReadMore = true }) => {

const [toScroll, setToScroll] = useState(false)

const toggleVisibility = () => {
    console.log("Read More", showReadMore)
     setToScroll(!toScroll)
};

    //console.log('HtmlViewer data: ', content)
    return (
        <>
            <p className={`${cssClass} ${toScroll ? 'overflow-visible' : null}` } dangerouslySetInnerHTML={{ __html: content }} />
            
            {
                showReadMore ?
                <button className={`btn btn-link btn-read-more d-none  ${toScroll && showReadMore ? 'd-md-none' : 'd-md-flex'} `}  onClick={() => toggleVisibility()} >Leer más</button>
                : null
            }
           
            
        </>
    )
}
